// @flow
import React from 'react';
import { useSelector } from 'react-redux';
import logo from '../../assets/icons/logo-i2i-big.svg';
import './terms.scss';
import terms from './terms.json';
import { toType } from '../../utils/helpers';
import { Typography } from "src/latest/src/components";

export const Bold = ({ children }) => <span className='terms__bold'>{children}</span>;
export const Text = ({ children, weight = 'regular', className = '' }) => <Typography variant='size-18' weight={weight} color='color-2'
    className={className}>{children.includes('span') || children.includes('<a') ? <span dangerouslySetInnerHTML={{ __html: children }}/> : children}</Typography>;

export default function TermsScreen(): React$Element<any> {
    const tenantSubdomain = useSelector(
        (state) => state?.configuration?.tenantSubdomain
    );
    let termsJSONString = JSON.stringify(terms);

    termsJSONString = termsJSONString.replace("{tenantSubdomain}", tenantSubdomain || "");
    const Terms = JSON.parse(termsJSONString);

    return (
        <div className='terms'>
            <div className='terms-wrapper'>
                <div className='terms__logo'>
                    <img src={logo} alt='logo'/>
                    <Typography
                        color='color-27'
                        weight='bold' variant='size-34' className='d-inline-block'>
                                i2i
                    </Typography>
                    <Typography
                        color='color-27'
                        weight='light' variant='size-34' className='d-inline-block'>
                                Connect
                    </Typography>
                </div>
                <div className='terms__header'>
                    <Typography variant='size-26' weight='light' color='color-2'>Terms of Service</Typography>
                    <Typography variant='size-16' weight='light' color='color-28'>Last Updated: September 1, 2021</Typography>
                </div>
                <div className='terms__section'>
                    <Text>The following terms and conditions by i2i LLC (“<Bold>i2i</Bold>”, “<Bold>we</Bold>” or “<Bold>us</Bold>”), apply to the i2iConnect.com website (the “<Bold>Website</Bold>”), and any related applications, online services and mobile applications provided by i2i (collectively, the “<Bold>Services</Bold>”). These Terms of Service together with our Privacy Policy (collectively, this “<Bold>Agreement</Bold>”) govern your use of the Services.</Text>
                </div>
                <div className='terms__section'>
                    <Text>This Agreement applies to any registered or a non-registered patient or other user of the Services (each a “<Bold>User</Bold>”), including a doctor, therapist, or other healthcare specialist, professional or provider using the Services in connection with a healthcare-related practice or other organization (each a “<Bold>Service Provider</Bold>”).</Text>
                </div>
                <div className='terms__section-main'>
                    <div className='terms__section'>
                        <Text>BY USING OR OTHERWISE ACCESSING THE SERVICES, AND/OR BY REGISTERING WITH US, YOU AGREE TO THIS AGREEMENT. IF YOU DO NOT AGREE, YOU CANNOT USE THE SERVICES.</Text>
                    </div>
                    <div className='terms__section'>
                        <Text>PLEASE SEE SECTIONS 9 AND 10 BELOW REGARDING YOUR LEGAL RIGHTS IN ANY DISPUTE INVOLVING OUR WEBSITES, SERVICES, TERMS OF SERVICE OR PRIVACY POLICY.</Text>
                    </div>
                </div>
                <div className='terms__section'>
                    <ul className='terms__section-main-list'>
                        {
                            Object.keys(Terms).map(main => <li>
                                <Text weight='bold'>{main}</Text>
                                <ul>
                                    {
                                        Object.keys(Terms[main]).map(secondary => toType(Terms[main]) === 'object' ? <li>
                                            { <Text weight='bold'>{secondary}</Text> }
                                            {
                                                Terms[main][secondary].map(v => toType(v) === 'string' ? <Text>{v}</Text> : <ul>
                                                    {v.map(vv => <li className='ms-3'><Text><span className='me-3'>•</span>{vv}</Text></li>)}
                                                </ul>)
                                            }
                                        </li> : <div className='terms__section-main-list__relative'>
                                            {toType(Terms[main][secondary]) === 'string' ? <Text>{Terms[main][secondary]}</Text> : <div>
                                                <ul className='pis-2'>
                                                    {
                                                        Terms[main][secondary].map(vv => <li className='ms-3 list-type-none'><Text><span className='me-3'>•</span>{vv}</Text></li>)
                                                    }
                                                </ul>
                                            </div>}
                                        </div>)
                                    }
                                </ul>
                            </li>)
                        }
                    </ul>
                </div>
            </div>
        </div>
    );
}
